import { LanguageXamlIcon } from './LanguageXamlIcon';

/**
 * author: Contributors
 * id 1AC4596D-76B2-4F11-AF23-157736CABB86
 * name language-xaml
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/language-xaml.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const XamlIcon = LanguageXamlIcon;
export default XamlIcon